var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2001 10.7996H13.2001L14.0001 7.59961H11.2001V5.99961C11.2001 5.17611 11.2001 4.39961 12.8001 4.39961H14.0001V1.71169C13.7395 1.67709 12.7545 1.59961 11.7144 1.59961C9.54282 1.59961 8.0001 2.9251 8.0001 5.35938V7.59961H5.6001V10.7996H8.0001V17.5996H11.2001V10.7996Z",
    fill: "#010103"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.2b92580524488c96b9bf4bdac4c02196.svg";
export { ForwardRef as ReactComponent };